import React, { Component } from "react";
import "../App.css";
import stillness from "../images/stillness.jpg";
import dune from "../images/dune.jpg";
import thinkAndGrowRich from "../images/think_and_grow_rich_book.jpg";
import embrace from "../images/fitness.jpg";

class MostPopular extends Component {
  render() {
    return (
      <div className="most-pop-wrapper">
        <h1>Most Popular User Picks</h1>
        <div className="most-pop-books-wrapper">
          <img
            src={stillness}
            className="most-pop_books"
            alt="Stillness is the Key by Ryan Holiday"
          />
          <img
            src={dune}
            className="most-pop_books"
            alt="Dune by Frank Herbert"
          />
          <img
            src={thinkAndGrowRich}
            className="most-pop_books"
            alt="Think and Grow Rich by Napoleon Hill"
          />
          <img
            src={embrace}
            className="most-pop_books"
            alt="Embrace the Suck by Stephen Madden"
          />
        </div>
      </div>
    );
  }
}

export default MostPopular;
